import React from 'react';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { Tooltip, useMediaQuery, useTheme } from '@material-ui/core';
import { handleOutsideTooltipClick } from 'src/utils/functions';
import { NEIGHBOURHOOD_TOOLTIP_Z_INDEX } from 'src/const';
import { makeStyles } from '@material-ui/core/styles';

const useStylesRoot = makeStyles({
  tooltip: {
    padding: 0,
    background: 'transparent',
  },
  popper: {
    zIndex: NEIGHBOURHOOD_TOOLTIP_Z_INDEX,
  },
  popperMobile: {
    zIndex: NEIGHBOURHOOD_TOOLTIP_Z_INDEX,
    transform: 'translate(20px, 40px) !important',
  },
});

const MapTooltipWrapper = ({
  icon,
  matches,
  TooltipComponent,
  handleTooltipOpen,
  handleTooltipClose,
  tooltipOpen,
  setTooltipOpen,
}) => {
  const rootClass = useStylesRoot();
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <ClickAwayListener
      onClickAway={(event: MouseEvent | TouchEvent) => {
        handleOutsideTooltipClick(event, tooltipOpen, setTooltipOpen);
      }}
    >
      <Tooltip
        interactive
        classes={rootClass}
        PopperProps={{
          className: isMobileScreen ? rootClass.popperMobile : rootClass.popper,
        }}
        open={tooltipOpen}
        onClose={handleTooltipClose}
        onOpen={handleTooltipOpen}
        disableHoverListener={matches}
        disableFocusListener={matches}
        disableTouchListener={!matches}
        enterTouchDelay={0}
        leaveTouchDelay={50000}
        placement={'top-start'}
        title={TooltipComponent}
      >
        {icon}
      </Tooltip>
    </ClickAwayListener>
  );
};

export default MapTooltipWrapper;
